import { UserIdentity } from './userIdentity';

import login, { isLoggedIn, handleLoginRedirect } from './login';
import initAuth0 from './initAuth0';
import logout from './logout';
import { extendSession, heartbeat } from './extendSession';
import clearSession from './clearSession';

export default abstract class Auth0Identity {
  /** @hidden */
  static _version = require('../../package.json').version;

  /** @hidden */
  private static _userIdentity: UserIdentity;

  static _auth0 = {};

  /**
   * An object which holds the user's identity information. Things like the `accessToken`, `refreshToken` and `uuid` will be stored here. e.g.
   * ```json
   * {
   *   "accessToken": "c7e9fed4bedf428b.a6941bbd21721cf7...",
   * }
   * ```
   *
   * The `userIdentity` property is a shortcut to `localStorage['ArcId.USER_INFO']` (or `sessionStorage['ArcId.USER_INFO']`) or our client-side cookie storage,
   * depending on what has been selected.
   */
  static get userIdentity(): UserIdentity {
    return this._userIdentity;
  }

  static set userIdentity(v: UserIdentity) {
    this._userIdentity = v;
  }

  static get auth0(): any {
    return this._auth0;
  }

  static set auth0(v: any) {
    this._auth0 = v;
  }

  static login = login;
  static isLoggedIn = isLoggedIn;
  static extendSession = extendSession;
  static heartbeat = heartbeat;
  static logout = logout;
  static initAuth0 = initAuth0;
  static handleLoginRedirect = handleLoginRedirect;
  static clearSession = clearSession;
}
